
















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/store/api';
import user from '@/store/modules/user';
import TemplateSelection from '@/views/TemplateSelection.vue';

@Component({ components: { TemplateSelection } })
export default class EditSie extends Vue {
  sie: any = {};
  currentIndex: number = 0;
  plModels: any = [];
  plModelTemplate: any = [
    { type: 'pl', field: 'NetSales', title: 'Nettoomsättning' },
    {
      type: 'pl',
      field: 'ChangeInventWorkProg',
      title: 'Förändring av varulager',
    },
    {
      type: 'pl',
      field: 'WorkPerfOwnUseCapital',
      title: 'Aktiverat arbete för egen räkning',
    },
    { type: 'pl', field: 'OtherOppIncome', title: 'Övriga rörelseintäkter' },
    { type: 'sum', field: 'NetOperatingIncome', title: 'Summa intäkter' },
    {
      type: 'pl',
      field: 'RawMatAndCons',
      title: 'Kostnader för varor och material',
    },
    { type: 'pl', field: 'OtherExtCosts', title: 'Övriga externa kostnader' },
    { type: 'pl', field: 'PersonalCosts', title: 'Personalkostnader' },
    { type: 'pl', field: 'OtherOppExpenses', title: 'Övriga rörelsekostnader' },
    { type: 'pl', field: 'DeprAndWriteDowns', title: 'Av- och nedskrivningar' },
    { type: 'sum', field: 'OperatingResult', title: 'Rörelseresultat' },
    {
      type: 'pl',
      field: 'ResultParticipationGroup',
      title: 'Intäkter från koncern & intresseföretag',
    },
    { type: 'pl', field: 'ExtInterestInc', title: 'Externa ränteintäkter' },
    {
      type: 'pl',
      field: 'FinIntGroupInc',
      title: 'Ränteintäkter från koncern & intresseföretag',
    },
    { type: 'pl', field: 'OtherFinInc', title: 'Övriga finansiella intäkter' },
    { type: 'pl', field: 'InterestExpExt', title: 'Externa räntekostnader' },
    {
      type: 'pl',
      field: 'InterestExpInt',
      title: 'Räntekostnader från koncern & intresseföretag',
    },
    {
      type: 'pl',
      field: 'OtherFinCosts',
      title: 'Övriga finansiella kostnader',
    },
    {
      type: 'sum',
      field: 'ProfLossAfterFinItems',
      title: 'Resultat efter finansiella poster',
    },
    { type: 'pl', field: 'GroupContrib', title: 'Koncernbidrag' },
    { type: 'pl', field: 'ShareholderContrib', title: 'Aktieägartillskott' },
    {
      type: 'pl',
      field: 'OtherAppropriations',
      title: 'Bokslutsdispositioner',
    },
    { type: 'pl', field: 'Tax', title: 'Skatt på årets resultat' },
    { type: 'sum', field: 'NetProfitLoss', title: 'ÅRETS RESULTAT' },
  ];
  bsModels: any = [];
  bsModelTemplate: any = [
    { type: 'title', field: '1', title: 'TILLGÅNGAR' },
    {
      type: 'bs',
      field: 'SubscribedCapitalUnpaid',
      title: 'Tecknat men ej inbetalt kapital',
    },
    { type: 'title', field: '2', title: 'Anläggningstillgångar' },
    {
      type: 'bs2',
      field: 'TotalIntangibleAssets',
      title: 'Immateriella anläggningstillgångar',
    },
    {
      type: 'bs2',
      field: 'TotalTangibleAssets',
      title: 'Materiella anläggningstillgångar',
    },
    {
      type: 'bs2',
      field: 'TotalFinancialAssets',
      title: 'Finansiella anläggningstillgångar',
    },
    {
      type: 'sum',
      field: 'TotFixAssets',
      title: 'Summa anläggningstillgångar',
    },
    { type: 'title', field: '3', title: 'Omsättningstillgångar' },
    {
      type: 'bs2',
      field: 'WorkOnContract',
      title: 'Pågående arbete för annans räkning',
    },
    { type: 'bs2', field: 'Inventories', title: 'Varulager' },
    { type: 'bs2', field: 'AccountsReceivableTrade', title: 'Kundfordringar' },
    {
      type: 'bs2',
      field: 'AccRecieveGroup',
      title: 'Fordringar koncern & intresseföretag',
    },
    {
      type: 'bs2',
      field: 'OtherAccRecieve',
      title: 'Övriga kortfristiga fordringar',
    },
    {
      type: 'bs2',
      field: 'ShortInvestments',
      title: 'Kortfristiga placeringar',
    },
    { type: 'bs2', field: 'CashAndBankBalances', title: 'Kassa och bank' },
    {
      type: 'bs2',
      field: 'OtherCurAssets',
      title: 'Övriga omsättningstillgångar',
    },
    {
      type: 'sum',
      field: 'TotalTurnoverAssets',
      title: 'Summa omsättningstillgångar',
    },
    { type: 'sum', field: 'TotAssets', title: 'SUMMA TILLGÅNGAR' },

    { type: 'title', field: '4', title: 'EGET KAPITAL OCH SKULDER' },
    {
      type: 'pldiff',
      field: '5',
      title: 'Resultatförändring (ingår i Eget kapital)',
    },
    { type: 'bs', field: 'TotEquity', title: 'Eget kapital' },
    { type: 'bs', field: 'UntaxedReserves', title: 'Obeskattade reserver' },
    { type: 'bs', field: 'Provisions', title: 'Avsättningar' },

    { type: 'title', field: '6', title: 'Långfristiga skulder' },
    { type: 'bs2', field: 'LtBondLoan', title: 'Obligationslån' },
    {
      type: 'bs2',
      field: 'LtLiabToCreditInstit',
      title: 'Långfristiga skulder till kreditinstitut',
    },
    {
      type: 'bs2',
      field: 'LtLiabGroupAssComp',
      title: 'Skulder till koncern & intresseföretag',
    },
    {
      type: 'sum',
      field: 'TotLongTermDebts',
      title: 'Summa långfristiga skulder',
    },

    { type: 'title', field: '7', title: 'Kortfristiga skulder' },
    {
      type: 'bs2',
      field: 'LiabCreditInst',
      title: 'Kortfristiga skulder till kreditinstitut',
    },
    { type: 'bs2', field: 'AccPayTrade', title: 'Leverantörsskulder' },
    {
      type: 'bs2',
      field: 'StLiabGroupAssComp',
      title: 'Skulder till koncern/intresseföretag (kortfristiga)',
    },
    {
      type: 'bs2',
      field: 'OtherShortTermLiab',
      title: 'Övriga kortfristiga skulder',
    },
    {
      type: 'sum',
      field: 'TotCurrentLiabilities',
      title: 'Summa kortfristiga skulder',
    },

    {
      type: 'sum',
      field: 'TotEquityAndLiab',
      title: 'SUMMA EGET KAPITAL OCH SKULDER',
    },
  ];

  derivedValues: any[] = [];

  async mounted() {
    if (user.selectedSieBlob) {
      this.sie = await api.getSie(user.selectedSieBlob);

      this.currentIndex = 0;

      this.sie.AccountProfitlossSheet.forEach((sheet: any, index: number) => {
        const plModelCopy = JSON.parse(JSON.stringify(this.plModelTemplate));
        this.plModels.push(plModelCopy);

        const bsModelCopy = JSON.parse(JSON.stringify(this.bsModelTemplate));
        this.bsModels.push(bsModelCopy);

        this.derivedValues.push({
          NetProfitLossDiff: 0,
          TotAssets: 0,
          TotAssetsDiff: 0,
          TotEquityAndLiab: 0,
          TotEquityAndLiabDiff: 0,
          initialUnbalance: false,
        });
      });

      this.derivedValues[0].initialUnbalance =
        this.getSum({ field: 'TotAssets' }) !==
        this.getSum({ field: 'TotEquityAndLiab' });
    }
    if (!this.bs) {
      await this.$router.push({ name: 'start' });
    }
  }

  getValue(item: any): number {
    return Number(this.getValueRaw(item));
  }

  getValueRaw(item: any): string {
    if (item.type === 'pl') {
      return this.pl[item.field];
    }
    if (item.type === 'bs' || item.type === 'bs2') {
      return this.bs[item.field];
    }
    return '0';
  }

  getSum(item: any): number {
    switch (item.field) {
      case 'NetOperatingIncome':
        return this.sum(this.pl, [
          'NetSales',
          'ChangeInventWorkProg',
          'WorkPerfOwnUseCapital',
          'OtherOppIncome',
        ]);
      case 'OperatingResult':
        return (
          this.getSum({ field: 'NetOperatingIncome' }) +
          this.sum(this.pl, [
            'RawMatAndCons',
            'OtherExtCosts',
            'PersonalCosts',
            'OtherOppExpenses',
            'DeprAndWriteDowns',
          ])
        );
      case 'ProfLossAfterFinItems':
        return (
          this.getSum({ field: 'OperatingResult' }) +
          this.sum(this.pl, [
            'ResultParticipationGroup',
            'ExtInterestInc',
            'FinIntGroupInc',
            'OtherFinInc',
            'InterestExpExt',
            'InterestExpInt',
            'OtherFinCosts',
          ])
        );
      case 'NetProfitLoss':
        return (
          this.getSum({ field: 'ProfLossAfterFinItems' }) +
          this.sum(this.pl, [
            'GroupContrib',
            'ShareholderContrib',
            'OtherAppropriations',
            'Tax',
          ])
        );
      case 'TotFixAssets':
        return this.sum(this.bs, [
          'SubscribedCapitalUnpaid',
          'TotalIntangibleAssets',
          'TotalTangibleAssets',
          'TotalFinancialAssets',
        ]);
      case 'TotalTurnoverAssets':
        return this.sum(this.bs, [
          'WorkOnContract',
          'Inventories',
          'AccountsReceivableTrade',
          'AccRecieveGroup',
          'OtherAccRecieve',
          'ShortInvestments',
          'CashAndBankBalances',
          'OtherCurAssets',
        ]);
      case 'TotAssets':
        this.derivedValues[this.currentIndex].TotAssets =
          this.getSum({ field: 'TotFixAssets' }) +
          this.getSum({ field: 'TotalTurnoverAssets' });
        return this.derivedValues[this.currentIndex].TotAssets;

      case 'TotEquityAndLiab':
        this.derivedValues[this.currentIndex].TotEquityAndLiab =
          this.getSum({ field: 'TotLongTermDebts' }) +
          this.getSum({ field: 'TotCurrentLiabilities' }) +
          this.sum(this.bs, ['TotEquity', 'UntaxedReserves', 'Provisions']);
        return this.derivedValues[this.currentIndex].TotEquityAndLiab;

      case 'TotLongTermDebts':
        return this.sum(this.bs, [
          'LtBondLoan',
          'LtLiabToCreditInstit',
          'LtLiabGroupAssComp',
        ]);
      case 'TotCurrentLiabilities':
        return this.sum(this.bs, [
          'LiabCreditInst',
          'AccPayTrade',
          'StLiabGroupAssComp',
          'OtherShortTermLiab',
        ]);

      case 'TotOppExp':
        return (
          this.getSum({ field: 'OperatingResult' }) -
          this.getSum({ field: 'NetOperatingIncome' })
        );
      case 'TotFinInvestments':
        return (
          this.getSum({ field: 'ProfLossAfterFinItems' }) -
          this.getSum({ field: 'OperatingResult' })
        );
    }
    return 0;
  }

  sum(source: any, fields: string[]): number {
    let sum = 0;
    for (const field of fields) {
      sum += Number(source[field]);
    }
    return sum;
  }

  getDiff(item: any): number {
    switch (item.field) {
      case 'NetOperatingIncome':
        return this.diff(this.plModel, [
          'NetSales',
          'ChangeInventWorkProg',
          'WorkPerfOwnUseCapital',
          'OtherOppIncome',
        ]);
      case 'OperatingResult':
        return (
          this.getDiff({ field: 'NetOperatingIncome' }) +
          this.diff(this.plModel, [
            'RawMatAndCons',
            'OtherExtCosts',
            'PersonalCosts',
            'OtherOppExpenses',
            'DeprAndWriteDowns',
          ])
        );
      case 'ProfLossAfterFinItems':
        return (
          this.getDiff({ field: 'OperatingResult' }) +
          this.diff(this.plModel, [
            'ResultParticipationGroup',
            'ExtInterestInc',
            'FinIntGroupInc',
            'OtherFinInc',
            'InterestExpExt',
            'InterestExpInt',
            'OtherFinCosts',
          ])
        );
      case 'NetProfitLoss':
        this.derivedValues[this.currentIndex].NetProfitLossDiff =
          this.getDiff({ field: 'ProfLossAfterFinItems' }) +
          this.diff(this.plModel, [
            'GroupContrib',
            'ShareholderContrib',
            'OtherAppropriations',
            'Tax',
          ]);
        return this.derivedValues[this.currentIndex].NetProfitLossDiff;
      case 'TotFixAssets':
        return this.diff(this.bsModel, [
          'SubscribedCapitalUnpaid',
          'TotalIntangibleAssets',
          'TotalTangibleAssets',
          'TotalFinancialAssets',
        ]);
      case 'TotalTurnoverAssets':
        return this.diff(this.bsModel, [
          'WorkOnContract',
          'Inventories',
          'AccountsReceivableTrade',
          'AccRecieveGroup',
          'OtherAccRecieve',
          'ShortInvestments',
          'CashAndBankBalances',
          'OtherCurAssets',
        ]);
      case 'TotAssets':
        this.derivedValues[this.currentIndex].TotAssetsDiff =
          this.getDiff({ field: 'TotFixAssets' }) +
          this.getDiff({ field: 'TotalTurnoverAssets' });
        return this.derivedValues[this.currentIndex].TotAssetsDiff;

      case 'TotEquityAndLiab':
        this.derivedValues[this.currentIndex].TotEquityAndLiabDiff =
          this.getDiff({ field: 'TotLongTermDebts' }) +
          this.getDiff({ field: 'TotCurrentLiabilities' }) +
          this.diff(this.bsModel, [
            'TotEquity',
            'UntaxedReserves',
            'Provisions',
          ]) +
          this.derivedValues[this.currentIndex].NetProfitLossDiff;
        return this.derivedValues[this.currentIndex].TotEquityAndLiabDiff;

      case 'TotLongTermDebts':
        return this.diff(this.bsModel, [
          'LtBondLoan',
          'LtLiabToCreditInstit',
          'LtLiabGroupAssComp',
        ]);
      case 'TotCurrentLiabilities':
        return this.diff(this.bsModel, [
          'LiabCreditInst',
          'AccPayTrade',
          'StLiabGroupAssComp',
          'OtherShortTermLiab',
        ]);
    }
    return 0;
  }

  diff(source: any, fields: string[]): number {
    let diff = 0;
    for (const field of fields) {
      for (const item of source) {
        if (item.field === field) {
          if (item.value) {
            diff += Number(item.value) - this.getValue(item);
          }
          break;
        }
      }
    }
    if (diff !== 0) {
      this.derivedValues[this.currentIndex].initialUnbalance = false;
    }
    return diff;
  }

  newSum(field: string): string {
    return '' + (this.getSum({ field }) + this.getDiff({ field }));
  }

  newVal(field: string): string {
    for (const source of [this.plModel, this.bsModel]) {
      for (const item of source) {
        if (item.field === field) {
          if (item.value) {
            return item.value;
          } else {
            return this.getValueRaw(item);
          }
        }
      }
    }
    return '0';
  }

  filterInput(event: any) {
    if (
      ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-'].indexOf(
        event.key,
      ) === -1
    ) {
      event.preventDefault();
    }
  }

  prev() {
    this.$router.back();
  }

  async update() {
    if (!this.canCreate) {
      return;
    }

    const sheets = this.plModels.length;

    const pls = [];
    const bss = [];
    for (let i = 0; i < sheets; i++) {
     this.currentIndex = i;
     pls.push({
      DateFrom: this.pl.DateFrom,
        DateTo: this.pl.DateTo,
        Months: this.pl.Months,
        NetProfitLoss: this.newSum('NetProfitLoss'),
        NetOperatingIncome: this.newSum('NetOperatingIncome'),
        NetSales: this.newVal('NetSales'),
        WorkPerfOwnUseCapital: this.newVal('WorkPerfOwnUseCapital'),
        OtherOppIncome: this.newVal('OtherOppIncome'),
        ChangeInventWorkProg: this.newVal('ChangeInventWorkProg'),
        OperatingResult: this.newSum('OperatingResult'),
        RawMatAndCons: this.newVal('RawMatAndCons'),
        OtherExtCosts: this.newVal('OtherExtCosts'),
        PersonalCosts: this.newVal('PersonalCosts'),
        DeprAndWriteDowns: this.newVal('DeprAndWriteDowns'),
        OtherOppExpenses: this.newVal('OtherOppExpenses'),
        ProfLossAfterFinItems: this.newSum('ProfLossAfterFinItems'),
        ResultParticipationGroup: this.newVal('ResultParticipationGroup'),
        ExtInterestInc: this.newVal('ExtInterestInc'),
        FinIntGroupInc: this.newVal('FinIntGroupInc'),
        OtherFinInc: this.newVal('OtherFinInc'),
        InterestExpExt: this.newVal('InterestExpExt'),
        InterestExpInt: this.newVal('InterestExpInt'),
        OtherFinCosts: this.newVal('OtherFinCosts'),
        OtherAppropriations: this.newVal('OtherAppropriations'),
        GroupContrib: this.newVal('GroupContrib'),
        ShareholderContrib: this.newVal('ShareholderContrib'),
        Tax: this.newVal('Tax'),
        TotOppExp: this.newSum('TotOppExp'),
        TotFinInvestments: this.newSum('TotFinInvestments'),
     });
     bss.push({
      DateFrom: this.bs.DateFrom,
        DateTo: this.bs.DateTo,
        Months: this.bs.Months,
        TotAssets: this.newSum('TotAssets'),
        TotFixAssets: this.newSum('TotFixAssets'),
        TotalIntangibleAssets: this.newVal('TotalIntangibleAssets'),
        TotalTangibleAssets: this.newVal('TotalTangibleAssets'),
        TotalFinancialAssets: this.newVal('TotalFinancialAssets'),
        SubscribedCapitalUnpaid: this.newVal('SubscribedCapitalUnpaid'),
        TotalTurnoverAssets: this.newSum('TotalTurnoverAssets'),
        Inventories: this.newVal('Inventories'),
        WorkOnContract: this.newVal('WorkOnContract'),
        AccountsReceivableTrade: this.newVal('AccountsReceivableTrade'),
        AccRecieveGroup: this.newVal('AccRecieveGroup'),
        OtherAccRecieve: this.newVal('OtherAccRecieve'),
        OtherCurAssets: this.newVal('OtherCurAssets'),
        ShortInvestments: this.newVal('ShortInvestments'),
        CashAndBankBalances: this.newVal('CashAndBankBalances'),
        TotEquityAndLiab: this.newSum('TotEquityAndLiab'),
        TotEquity:
          '' +
          (Number(this.newVal('TotEquity')) +
            this.getDiff({ field: 'NetProfitLoss' })),
        UntaxedReserves: this.newVal('UntaxedReserves'),
        Provisions: this.newVal('Provisions'),
        TotLongTermDebts: this.newSum('TotLongTermDebts'),
        LtBondLoan: this.newVal('LtBondLoan'),
        LtLiabToCreditInstit: this.newVal('LtLiabToCreditInstit'),
        LtLiabGroupAssComp: this.newVal('LtLiabGroupAssComp'),
        TotCurrentLiabilities: this.newSum('TotCurrentLiabilities'),
        LiabCreditInst: this.newVal('LiabCreditInst'),
        AccPayTrade: this.newVal('AccPayTrade'),
        StLiabGroupAssComp: this.newVal('StLiabGroupAssComp'),
        OtherShortTermLiab: this.newVal('OtherShortTermLiab'),
     });
    }

    const doc = {
      Version: 1,
      SieId: user.selectedSie,
      Profitloss: pls,
      Balance: bss,
    };

    const OrgNr = await api.updateSie(doc);
    await user.getUser('Uppdaterar SIE-fil');
    // user.setActiveSie(null);
    this.prev();
  }

  get plModel() {
    return this.plModels[this.currentIndex];
  }

  get bsModel() {
    return this.bsModels[this.currentIndex];
  }

  get derived() {
    return this.derivedValues[this.currentIndex];
  }

  get canCreate() {
    return !this.hasBsDiff;
  }

  get bs() {
    if (this.sie.AccountBalanceSheet && this.sie.AccountBalanceSheet[this.currentIndex]) {
      return this.sie.AccountBalanceSheet[this.currentIndex];
    }
    return null;
  }

  get pl() {
    if (this.sie.AccountProfitlossSheet && this.sie.AccountProfitlossSheet[this.currentIndex]) {
      return this.sie.AccountProfitlossSheet[this.currentIndex];
    }
    return null;
  }

  get hasPlDiff(): boolean {
    return this.derived.NetProfitLossDiff !== 0;
  }

  get hasBsDiff(): boolean {
    return (
      this.derived.TotAssets + this.derived.TotAssetsDiff !==
      this.derived.TotEquityAndLiab + this.derived.TotEquityAndLiabDiff
    );
  }

   get bsDiff(): number {
    return (
      this.derived.TotAssets +
      this.derived.TotAssetsDiff -
      (this.derived.TotEquityAndLiab + this.derived.TotEquityAndLiabDiff)
    );
  }

  get hasMultipleSheets(): boolean {
    return true;
  }

  get availableSheets(): any[] {
    // Use the longer array to determine available sheets
    const plSheets = this.sie.AccountProfitlossSheet || [];
    const bsSheets = this.sie.AccountBalanceSheet || [];
    return plSheets.length >= bsSheets.length ? plSheets : bsSheets;
  }

  getSheetDisplayName(sheet: any, index: number): string {
    if (sheet && sheet.DateFrom && sheet.DateTo) {
      const months = sheet.Months || 12;
      return `${sheet.DateFrom} - ${sheet.DateTo} (${months} månader)`;
    }
    if (sheet && (sheet.DateFrom || sheet.DateTo)) {
      const date = sheet.DateFrom || sheet.DateTo;
      return `${date} (Period ${index + 1})`;
    }
    return `Period ${index + 1}`;
  }
}
